import Action from "../actions";

export default function couponManagementReducer(state = {
    viewList: {
        couponList: [],
        total: 0
    },
    addNew: {
        applicableObject: {
            list: [],
            total: 0
        },
        type: '',
    },
    viewDetail: {
        original: {
            applicableObject: {
                list: [],
                total: 0
            },
            coupon: null,
        },
        editable: {
            applicableObject: {
                list: [],
                total: 0
            },
            coupon: null,
            type: '',

        },
        selected: null,
    }
}, action) {
    if (action.type === Action.SET_COUPON_MANAGEMENT) {
        return action.data;
    }
    return state;
}
